import type { ReactNode } from 'react';
import type { HotelRoom } from '@/interfaces';

export const mapInclusions = (offerId: string, inclusions: readonly string[], hasFreeCancellation = false, limit = 4): ReactNode =>
    inclusions
        .concat(hasFreeCancellation ? ['Gratis avbestilling'] : [])
        .map((inclusion) => <li key={`offer-inclusion-${offerId}-${inclusion}`}>{inclusion}</li>)
        .slice(0, limit);

export const mapHotelRoom = (offerId: string, rooms: readonly HotelRoom[], classNames = 'u-pl16-gt640'): ReactNode =>
    rooms.map((room) => (
        <h4 key={`offer-room-name-${offerId}`} className={classNames} title={room.description}>
            {room.name}
        </h4>
    ));
